import { useConfig } from '../../config/config.context';

/**
 * Base URL du service de formulaires (registrations), dérivée de l'origin de
 * l'endpoint platform et de l'eventId :
 *   `https://api.appcraft.events/registrations/v1/{eventId}/web/form`
 */
export function useRegistrationsFormBaseUrl(): string {
  const { eventId /*, endpoints */ } = useConfig();
  // `endpoints.platform` peut être absolu (`https://api…`) ou relatif (`/xxx/api`) :
  // on résout contre l'origin courant pour éviter un `Invalid URL`.
  // const { origin } = new URL(endpoints.platform, window.location.origin);
  const origin = 'https://api.appcraft.events'; // TODO: use a generic mapping for forms
  return `${origin}/registrations/v1/${eventId}/web/form`;
}

type BuildOptions = {
  /** Ouvre le formulaire en édition sur l'enregistrement (`/k/{privateKey}`) */
  privateKey?: string;
  /** Paramètres de query supplémentaires (ex. `{ parentId }`) */
  query?: Record<string, string | undefined>;
};

/**
 * Construit l'URL d'un formulaire registrations :
 * - création : `${base}/${formSlug}`
 * - édition  : `${base}/${formSlug}/k/${privateKey}`
 * Les `query` non vides sont ajoutés en query string.
 */
export function buildRegistrationFormUrl(
  baseUrl: string,
  formSlug: string,
  { privateKey, query = {} }: BuildOptions = {},
): string {
  const formUrl = privateKey ? `${baseUrl}/${formSlug}/k/${privateKey}` : `${baseUrl}/${formSlug}`;
  const params = Object.entries(query)
    .filter(([, value]) => value != null && value !== '')
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value as string)}`)
    .join('&');
  if (!params) return formUrl;
  const separator = formUrl.includes('?') ? '&' : '?';
  return `${formUrl}${separator}${params}`;
}
